import { Component } from '@angular/core';
import { BackButtonComponent } from 'app/common/components/back-button/back-button.component';
import { ChipComponent } from 'app/common/components/chip/chip.component';
import { ContentCardComponent } from 'app/common/components/content-card/content-card.component';
import { LinksComponent } from 'app/common/components/links/links.component';
import { AboutBackstageComponent } from './components/about-backstage/about-backstage.component';
import { ChatComponent } from './components/chat/chat.component';
import { FooterComponent } from 'app/footer/footer.component';

@Component({
  selector: 'app-backstage',
  templateUrl: './backstage.component.html',
  styleUrls: ['./backstage.component.less'],
  imports: [
    ContentCardComponent,
    BackButtonComponent,
    ChipComponent,
    LinksComponent,
    AboutBackstageComponent,
    ChatComponent,
    FooterComponent,
  ],
})
export class BackstageComponent {
  Instagram = 'https://www.instagram.com/neuburgervolkstheater/';
  Facebook = 'https://www.facebook.com/VolkstheaterNeuburg';
  Color = '#21538d';

  chips = ['Angular', 'ASP.NET', 'Nginx'];
}
